import { IMG } from "../content";
import { Reveal } from "./Reveal";

const COACHES = [
  {
    name: "Agnieszka",
    specialty: "Mindset & Mindfulness Coach",
    bio: "Agnieszka is a certified Mindfulness Coach with training in neuropsychology, an entrepreneur, traveler, and mom of a competitive basketball player. She combines mindfulness, mindset work, and real-life experience to help athletes build confidence, handle pressure, strengthen resilience, and develop mental tools that support them both in sports and in life.",
    photo: IMG.agnieszka,
    alt: "Agnieszka wearing a white Mindful Athlete t-shirt, smiling",
    id: "agnieszka",
  },
  {
    name: "Nika",
    specialty: "Mobility, Recovery & Nervous-System Regulation",
    bio: "Nika is a certified yoga, dance, and stretching instructor with over a decade of teaching experience. She combines mobility, stretching, breathwork, body awareness, and guided meditation to help athletes recover, reconnect with their bodies, regulate the nervous system, and perform from a more balanced state — both in sport and in life.",
    photo: IMG.nika,
    alt: "Nika wearing a white Mindful Athlete t-shirt",
    id: "nika",
  },
];

const Coaches = () => (
  <section className="coaches section-pad" data-testid="coaches-section">
    <Reveal className="section-head-center">
      <p className="eyebrow" data-testid="coaches-eyebrow">The people</p>
      <h2 className="section-heading">Meet Your Coaches</h2>
    </Reveal>
    <div className="coach-grid">
      {COACHES.map((coach, i) => (
        <Reveal key={coach.id} delay={i * 0.15}>
          <article className="coach-card" data-testid={`coach-${coach.id}`}>
            <div className="coach-photo">
              <img src={coach.photo} alt={coach.alt} loading="lazy" />
            </div>
            <div className="coach-info">
              <h3>{coach.name}</h3>
              <p className="coach-spec">{coach.specialty}</p>
              <p className="coach-bio">{coach.bio}</p>
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Coaches;
